/** How a meter moved in the snapshot that just arrived; dice report a new roll instead of a delta. */
var MeterMoveDirection;
(function (MeterMoveDirection) {
    MeterMoveDirection["Up"] = "up";
    MeterMoveDirection["Down"] = "down";
    MeterMoveDirection["Roll"] = "roll";
})(MeterMoveDirection || (MeterMoveDirection = {}));
export default MeterMoveDirection;
